import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Loader from '../Loader';

function PrivateRoute({ component: Component, ...props }) {
  return (
    <Route
      {...props}
      render={renderProps => {
        return (
          <div className="flex flex-1 flex-col">
            <div className="flex flex-1 flex-col">
              <Suspense fallback={Loader}>
                <Component {...renderProps} />
              </Suspense>
            </div>
          </div>
        );
      }}
    />
  );
}

PrivateRoute.propTypes = {
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  location: PropTypes.object,
  component: PropTypes.shape({
    render: PropTypes.func,
  }),
};

export default PrivateRoute;
